module.exports = __webpack_public_path__ + "img/expand_more-blue-18dp.063bfd30.svg";